// extracted by mini-css-extract-plugin
export var actionButton = "_d5-0";
export var attachmentLine = "_d5-1";
export var fileInput = "_d5-2";
export var fileUploadWrapper = "_d5-4";
export var footer = "_d5-3";
export var modalContent = "_d5-5";
export var paperclip = "_d5-6";
export var quillEditor = "_d5-7";